<div class="login-page">
  <p-toast />

  <!-- Lado Esquerdo - Hero Section com Beneficios -->
  <div class="login-hero">
    <div class="hero-content">
      <!-- Logo -->
      <div class="hero-logo">
        <img src="assets/images/logo_avatipro.png" alt="Avati Pro" />
      </div>

      <!-- Titulo Principal -->
      <h1 class="hero-title">{{ 'login.hero.titulo' | translate }}</h1>
      <p class="hero-subtitle">{{ 'login.hero.subtitulo' | translate }}</p>

      <!-- Lista de Beneficios -->
      <div class="benefits-list">
        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="pi pi-chart-line"></i>
          </div>
          <div class="benefit-text">
            <h3>{{ 'login.benefits.gestao_completa.titulo' | translate }}</h3>
            <p>{{ 'login.benefits.gestao_completa.descricao' | translate }}</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="pi pi-mobile"></i>
          </div>
          <div class="benefit-text">
            <h3>{{ 'login.benefits.acesso_facil.titulo' | translate }}</h3>
            <p>{{ 'login.benefits.acesso_facil.descricao' | translate }}</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <i class="pi pi-shield"></i>
          </div>
          <div class="benefit-text">
            <h3>{{ 'login.benefits.seguranca.titulo' | translate }}</h3>
            <p>{{ 'login.benefits.seguranca.descricao' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Circulos Decorativos -->
    <div class="decorative-circle circle-1"></div>
    <div class="decorative-circle circle-2"></div>
    <div class="decorative-circle circle-3"></div>
  </div>

  <!-- Lado Direito - Formulario -->
  <div class="login-form-section">
    <div class="form-container">
      <!-- Header do Formulario -->
      <div class="form-header">
        <h2>{{ 'login.form.titulo' | translate }}</h2>
        <p>{{ 'login.form.subtitulo' | translate }}</p>
      </div>

      <!-- Formulario -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-content">
        <!-- Campo Email -->
        <div class="input-group">
          <label for="email">{{ 'login.labels.email' | translate }}</label>
          <div class="input-wrapper">
            <i class="pi pi-envelope input-icon"></i>
            <input
              pInputText
              id="email"
              formControlName="email"
              type="email"
              [placeholder]="'login.placeholders.email' | translate"
            />
          </div>
          <small class="error-text" *ngIf="submitted && loginForm.controls['email'].hasError('required')">
            {{ 'login.notes.campo_obrigatorio' | translate }}
          </small>
          <small class="error-text" *ngIf="submitted && loginForm.controls['email'].hasError('email')">
            {{ 'login.notes.e_mail_invalido' | translate }}
          </small>
        </div>

        <!-- Campo Senha -->
        <div class="input-group">
          <label for="password">{{ 'login.labels.senha' | translate }}</label>
          <div class="input-wrapper password-wrapper">
            <i class="pi pi-lock input-icon"></i>
            <p-password
              formControlName="password"
              id="password"
              [toggleMask]="true"
              [feedback]="false"
              [placeholder]="'login.placeholders.senha' | translate"
              styleClass="custom-password"
            ></p-password>
          </div>
          <small class="error-text" *ngIf="submitted && loginForm.controls['password'].hasError('required')">
            {{ 'login.notes.campo_obrigatorio' | translate }}
          </small>
        </div>

        <!-- Checkbox Lembrar Email + Link Esqueci Senha -->
        <div class="remember-email">
          <div class="remember-email-left">
            <p-checkbox
              [(ngModel)]="rememberEmail"
              [ngModelOptions]="{standalone: true}"
              [binary]="true"
              inputId="rememberEmail"
            ></p-checkbox>
            <label for="rememberEmail">{{ 'login.labels.lembrar_email' | translate }}</label>
          </div>
          <a class="forgot-password" [routerLink]="['/newPasswordRequire']">
            {{ 'login.links.esqueci_minha_senha' | translate }}
          </a>
        </div>

        <!-- Botao Entrar -->
        <button
          pButton
          type="submit"
          [label]="'login.buttons.entrar' | translate"
          icon="pi pi-sign-in"
          iconPos="right"
          class="btn-entrar"
        ></button>
      </form>

      <div class="divider">
        <span>{{ 'social_login.ou_continue_com' | translate }}</span>
      </div>

      <div class="social-buttons">
        <button
          type="button"
          class="btn-social-google"
          (click)="loginComGoogle()"
          [disabled]="loadingGoogle"
          [attr.aria-label]="'social_login.botao_google' | translate"
          [attr.aria-busy]="loadingGoogle"
        >
          <i *ngIf="loadingGoogle" class="pi pi-spin pi-spinner"></i>
          <img *ngIf="!loadingGoogle" src="assets/images/google-icon.svg" alt="Google" />
          <span>{{ 'social_login.botao_google' | translate }}</span>
        </button>

        <button
          type="button"
          class="btn-social-apple"
          (click)="loginComApple()"
          [disabled]="loadingGoogle || loadingApple"
          [attr.aria-label]="'social_login.botao_apple' | translate"
          [attr.aria-busy]="loadingApple"
        >
          <i *ngIf="loadingApple" class="pi pi-spin pi-spinner"></i>
          <img *ngIf="!loadingApple" src="assets/images/apple-icon.svg" alt="Apple" />
          <span>{{ 'social_login.botao_apple' | translate }}</span>
        </button>
      </div>

      <!-- CTA Cadastro -->
      <div class="cta-cadastro">
        <p class="cta-text">{{ 'login.cta.novo_por_aqui' | translate }}</p>
        <button
          pButton
          type="button"
          [label]="'login.cta.criar_conta' | translate"
          icon="pi pi-user-plus"
          severity="success"
          class="btn-cadastrar"
          [routerLink]="['/signup']"
        ></button>
      </div>

      <!-- Suporte via WhatsApp -->
      <div class="cta-suporte">
        <button
          type="button"
          class="btn-suporte-whatsapp"
          (click)="abrirSuporteWhatsApp()"
          [attr.aria-label]="'login.suporte.botao' | translate"
        >
          <i class="pi pi-whatsapp"></i>
          <span>{{ 'login.suporte.botao' | translate }}</span>
        </button>
      </div>

    </div>
  </div>
</div>
